import { put, takeEvery, call } from "redux-saga/effects";
import { PostConstants } from "../constants/post.constants";
import { CorrectionConstants } from "../constants/correction.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    togglePostReactionSuccess,
    togglePostReactionFailure
} from "../actions/post.actions";
import {
    toggleCorrectionReactionSuccess,
    toggleCorrectionReactionFailure
} from "../actions/correction.actions";
import { Reaction } from "../records/post.record";

export function* togglePostReaction() {
    yield takeEvery(PostConstants.TOGGLE_POST_REACTION, doTogglePostReaction);
}

function insertReaction(value, userId, idType, action) {
    let { reactions } = value;
    if (action === "remove") {
        reactions = reactions.filter(r => r.userId !== userId);
    } else if (action === "add") {
        if (!reactions.find(r => r.userId === userId)) {
            reactions = reactions.push(
                new Reaction({
                    id: idType + "_" + value.id,
                    userId: userId,
                    creationDate: new Date()
                })
            );
        }
    }
    return value.merge({ reactions });
}

function* doTogglePostReaction({ payload: { post, active, userId } }) {
    try {
        const action = active ? "remove" : "add";
        yield updateReaction(post.id, "post", action);
        const newPost = insertReaction(post, userId, "post", action);
        yield put(togglePostReactionSuccess({ post: newPost }));
    } catch (e) {
        yield call(handleFailure, e, togglePostReactionFailure);
    }
}

export function* toggleCorrectionReaction() {
    yield takeEvery(
        CorrectionConstants.TOGGLE_CORRECTION_REACTION,
        doToggleCorrectionReaction
    );
}

function* doToggleCorrectionReaction({
    payload: { correction, active, userId }
}) {
    try {
        const action = active ? "remove" : "add";
        yield updateReaction(correction.id, "correction", action);
        const newCorrection = insertReaction(
            correction,
            userId,
            "correction",
            action
        );
        yield put(
            toggleCorrectionReactionSuccess({ correction: newCorrection })
        );
    } catch (e) {
        yield call(handleFailure, e, toggleCorrectionReactionFailure);
    }
}

function* updateReaction(id, idType, action = "add") {
    const query = `mutation {
		updateReaction(
			id: ${JSON.stringify(id)},
			idType: ${idType},
			action: ${action}
		)
	}`;
    return yield call(doGraphQLQuery, query);
}



// WEBPACK FOOTER //
// ./src/sagas/reaction.saga.js